export const pixelPurchaseParams = (pixels, cart, show) => {
  const pixelsPurchase = []
  if (!!pixels) {
    return pixelsPurchase
  }

  const { email } = cart.customer
  const { order_id } = cart
  const bundle = Object.values(cart.items.bundles)[0]
  const product = {
    id: bundle.external_ref,
    price: bundle.price,
    quantity: bundle.qty,
  }

  pixels.forEach((pixel) => {
    Object.entries(pixel).forEach(([key, value]) => {
      value.events = value.events.filter((events) => {
        return events.type == 'purchase' || events.type == 'allPages'
      })

      const { params, type } = Object.values(value.events)[0]

      if (type == 'allPages') {
        pixelsPurchase.push(pixel)
        return
      }

      if (params.showOn != show && params.showOn != 'all') {
        return
      }

      params.customer_email = email
      params.order_id = order_id
      params.product = product

      pixelsPurchase.push(pixel)
    })
  })

  return pixelsPurchase
}
